import { PERSONAL_PAGE_SUBTYPE_LABELS } from '../../labels';
import { cap } from '../capability-builder';
import { registrantLabels, registrantOptions, ticketLabels, ticketOptions } from '../item-presets';
import type { PersonalPageCapabilities } from '../types';

export const eventCapabilities: Record<string, PersonalPageCapabilities> = {
  ticketSales: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.ticketSales.singular,
    hasLocation: true,
    hasDateTime: true,
    requiresDefinedItems: true,
    itemKind: 'ticket',
    itemOptions: ticketOptions,
    dataDestination: 'registrations',
    itemLabels: ticketLabels,
    defineStepLabelConfig: {
      formSubject: 'רכישת כרטיסים',
      overrides: {
        registrationLimitTitle: 'מכסה כוללת לדף',
        registrationLimitSubtitle: 'הגבלת סך הכרטיסים בדף (בנוסף למלאי לכל סוג כרטיס)'
      }
    },
    defineStepChoice: {
      label: 'מכירת כרטיסים',
      helpText: 'הגדרת סוגי כרטיסים בתשלום עם מלאי וקופונים.',
      icon: 'confirmation'
    }
  }),

  freeEventRegistration: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.freeEventRegistration.singular,
    hasLocation: true,
    hasDateTime: true,
    itemKind: 'registrantType',
    itemOptions: registrantOptions,
    dataDestination: 'registrations',
    itemLabels: registrantLabels,
    defineStepLabelConfig: {
      formSubject: 'הרשמה',
      overrides: {
        registrationLimitTitle: 'מספר הרשמות כולל',
        registrationLimitSubtitle: 'הגבלת סך הנרשמים בדף (בנוסף למלאי לכל סוג נרשם)'
      }
    },
    defineStepChoice: {
      label: 'הרשמה חינמית',
      helpText: 'הרשמה לאירוע ללא תשלום, עם אפשרות להגביל מספר נרשמים.',
      icon: 'volunteer'
    }
  }),

  choiceEvent: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.choiceEvent.singular,
    hasLocation: true,
    hasDateTime: true,
    allowSubtypeChoice: true,
    subtypeChoiceOptions: ['ticketSales', 'freeEventRegistration'],
    dataDestination: 'registrations',
    itemLabels: ticketLabels,
    defineStepLabelConfig: {
      formSubject: 'הרשמה',
      overrides: { choiceSectionTitle: 'בחר צורת הרשמה' }
    }
  })
};
